import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  type: "submit",
  class: "btns btn-primary"
}

import { onMounted, ref } from 'vue'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import UsernameInput from './UsernameInput.vue'

import { useWait } from '@/app/composables/useWait'
import { ValidationState, setFocus } from '@/helpers/form'
import { backend } from '@/services/backend'
import type { Comment, Thread } from '@/models/interfaces'
import type { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentReply',
  props: {
    doc: {},
    thread: {},
    comment: {}
  },
  emits: ["replyPosted"],
  setup(__props: any, { emit: __emit }) {

const EMPTY_COMMENT = { id: null, text: '' }

const props = __props

const wait = useWait()
const emit = __emit

const input = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const validation = ref(new ValidationState())
const model = ref<any>(Object.assign({}, EMPTY_COMMENT))

async function save(): Promise<void> {
  try {
    wait.start('Posting Reply')
    // Send the reply to backend.
    const reply = await backend.saveReply(
      props.doc,
      props.thread,
      props.comment,
      model.value,
    )

    // Update comment replies with new reply.
    /* eslint-disable vue/no-mutating-props */
    props.comment.replies.push(reply)
    // Set the "notify_new_comment" toggle for the parent thread
    if (reply.notify_new_comment !== undefined) {
      props.thread.notify_new_comment = reply.notify_new_comment
    }
    /* eslint-enable vue/no-mutating-props */
    reply.parent = props.comment

    // Reset the form state.
    validation.value.reset()
    model.value = Object.assign({}, EMPTY_COMMENT)

    // Notify parent compoment that the reply was posted
    // (parent component hides the reply form in the even handler).
    emit('replyPosted', props.comment)
  } catch (error) {
    validation.value.showErrors(error)
  } finally {
    wait.end('Posting Reply')
  }
}

function focusInput(): void {
  setFocus(input.value?.$el)
}

onMounted(() => {
  focusInput()
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createElementBlock("form", {
    class: "reply-form form",
    novalidate: "",
    onSubmit: _withModifiers(save, ["prevent"])
  }, [
    _createVNode(UsernameInput, {
      model: model.value,
      validation: validation.value
    }, null, 8, ["model", "validation"]),
    _createVNode(InputWithContextMenu, {
      ref_key: "input",
      ref: input,
      modelValue: model.value.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.text) = $event)),
      elementType: "textarea",
      rows: "1",
      type: "text",
      class: _normalizeClass(["form-control reply-form__text", validation.value.stateClass('text')]),
      placeholder: "Write a reply..."
    }, null, 8, ["modelValue", "class"]),
    _createVNode(FormError, {
      errors: validation.value.errors,
      field: "text"
    }, null, 8, ["errors"]),
    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_1, [
      _createVNode(_component_v_wait, { for: "Posting Reply" }, {
        waiting: _withCtx(() => [
          _cache[1] || (_cache[1] = _createTextVNode(" Posting ", -1)),
          _createVNode(ButtonSpinner)
        ]),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" Post Reply ", -1))
        ]),
        _: 1
      })
    ])), [
      [_directive_wait, 'Posting Reply', "disabled"]
    ])
  ], 32))
}
}

})